export const messages = {
  en: {
    togo: {
      title: "Find the right GoBag or GoBox for your To-Go containers!",
      subtitle:
        "Select a common to-go container from the dropdown menu or enter your own dimensions below and we’ll show you how many you can fit.",
      measurement_instructions: {
        title: "How to measure your To-Go container",
      },
      units: {
        inches: "Inches",
        centimeters: "Centimeters",
      },
      measurement_labels: {
        width: {
          title: "Width",
          description: "The shorter of the two edges",
        },
        height: {
          title: "Height",
          description: "Measure vertically straight up, not along the angle",
        },
        length: {
          title: "Length",
          description: "The longer of the two edges",
        },
        quantity: {
          title: "Qty",
        },
      },
      optional_hint: "How many To-Go containers or Food Pans are you transporting?",
      optional: "optional",
      actions: {
        find_gobag: "Find My GoBag",
        find_gobox: "Find My GoBox",
      },
      note:
        "<strong> Note: </strong> this calculator is designed to provide general information. Please contact a Cambro rep to verify prior to order.",
      search_results: {
        your_togo_container: "{containerDescription}",
        your_food_pan: "{foodPanDescription}",
        options: {
          gobag: "GoBag",
          gobox: "GoBox",
          gobags: "GoBags",
          goboxes: "GoBoxes",
          container: "To-Go containers",
          foodpan: "food pans",
        },
        actions: {
          size_another_container: "Size another container",
          product_page: "Product Page",
          quote_request: "Quote Request",
        },
        hold_capacity_message:
          "This {transporterType} can hold {numBoxes} of your {formattedContainerType}.",
        containers_needed_count_message:
          "You need {numBags} of these {transporterType} to carry {count} {formattedContainerType}.",
      },
    },
  },
  es: {
    togo: {
      title:
        "Encuentra la GoBag o GoBox correcta para tus contenedores para llevar",
    },
  },
  fr: {
    togo: {
      title: "Trouvez le bon sac isotherme GoBag ou le bon conteneur isotherme ultra-léger GoBox pour transporter et livrer vos repas en toute sécurité!",
      subtitle:
        "Entrez les dimensions de vos bacs/récipients à emporter et nous vous indiquerons combien vous pouvez en mettre dans les conteneurs/sacs.",
      measurement_instructions: {
        title: "COMMENT MESURER VOTRE RÉCIPIENTS/BACS À EMPORTER",
      },
      units: {
        inches: "Pouces",
        centimeters: "Centimètre",
      },
      measurement_labels: {
        width: {
          title: "Largeur",
          description: "Le plus court des deux bords",
        },
        height: {
          title: "Hauteur",
          description: "Mesurez verticalement tout en haut, pas dans l'angle",
        },
        length: {
          title: "Longueur",
          description: "Le plus long des deux bords",
        },
        quantity: {
          title: "Quantité",
        },
      },
      optional_hint: "Combien de bacs/récipients à emporter transportez-vous?",
      optional: "Optionnel",
      actions: {
        find_gobag: "Trouver mon sac isotherme GoBag",
        find_gobox: "Trouver mon conteneur isotherme GoBox",
      },
      note:
        "<strong> Remarque: </strong> cette calculatrice est conçue pour fournir des informations générales. Veuillez contacter un représentant Cambro pour vérifier avant de passer commande.",
      search_results: {
        your_togo_container: "VOTRE RÉCIPIENTS/BACS À EMPORTER",
        options: {
          gobag: "sac isotherme GoBag",
          gobox: "conteneur isotherme GoBox",
          gobags: "sac isotherme GoBags",
          goboxes: "conteneur isotherme GoBoxes",
        },
        actions: {
          size_another_container: "Mesurer un autre bac/récipient",
          product_page: "Page du produit",
          quote_request: "Demander un devis",
        },
        hold_capacity_message:
          "Ce {transporterType} peut contenir {numBoxes} de vos bacs/récipients à emporter.",
        containers_needed_count_message:
          "You need {numBags} of these {transporterType} to carry {count} containers",
      },
    },
  },
  de: {
    togo: {
      title: "Finden Sie die richtige GoBag und GoBox für Ihre Behälter",
      subtitle:
        "Geben Sie die Abmessungen von Ihrers Behälters ein, und wir errechnen das Fassungsvermögen",
      measurement_instructions: {
        title: "Wie messen Sie Ihren To-Go Behälter richtig",
      },
      units: {
        inches: "Zoll",
        centimeters: "Zentimeter",
      },
      measurement_labels: {
        width: {
          title: "Breite",
          description: "Die kürzeste Seite",
        },
        height: {
          title: "Höhe",
          description: "Messen Sie senkrecht nach oben",
        },
        length: {
          title: "Länge",
          description: "Die Längste Seite",
        },
        quantity: {
          title: "Menge",
        },
      },
      optional_hint: "Wie vilele Behälter müssen Sie transportieren?",
      optional: "optional",
      actions: {
        find_gobag: "Finde meine GoBag",
        find_gobox: "Finde meine GoBox",
      },
      note:
        "<strong> Hinweis: </strong> Dieser Rechner bietet allgemeine Informationen. Bitte kontaktieren Sie einen Cambro-Vertreter, um dies vor Bestellung zu überprüfen. ",
      search_results: {
        your_togo_container: "Ihr To-Go-Behälter",
        options: {
          gobag: "GoBag",
          gobox: "GoBox",
          gobags: "GoBags",
          goboxes: "GoBoxes",
        },
        actions: {
          size_another_container: "Größe des nächsten Behälters",
          product_page: "Produktseite",
          quote_request: "Senden Sie mir ein Angebot",
        },
        hold_capacity_message:
          "Diese {transporterType} fasst {numBoxes} von Ihren To-Go Behältern",
        containers_needed_count_message:
          "You need {numBags} of these {transporterType} to carry {count} containers",
      },
    },
  },
  ru: {
    togo: {
      title: "Найти правильный GoBag или GoBox для ваших контейнеров/ коробок!",
      subtitle:
        "Введите размеры вашего контейнера/ коробки и мы покажем вам, сколько их поместиться.",
      measurement_instructions: {
        title: "КАК ИЗМЕРИТЬ ВАШ To-Go КОНТЕЙНЕР",
      },
      units: {
        inches: "Дюймы",
        centimeters: "Сантиметры",
      },
      measurement_labels: {
        width: {
          title: "Ширина",
          description: "Ширина",
        },
        height: {
          title: "Высота",
          description: "Измерьте вертикально прямо вверх, не вдоль угла",
        },
        length: {
          title: "Длина",
          description: "Длина",
        },
        quantity: {
          title: "Количество",
        },
      },
      optional_hint: "Сколько контейнеров/ коробок на Вы перевозите?",
      optional: "Дополнительный",
      actions: {
        find_gobag: "Найти Мой GoBag",
        find_gobox: "Найти Мой GoBox",
      },
      note:
        "<strong> Примечание: </strong> этот калькулятор предназначен для обобщенного подсчета. Пожалуйста контактируйте с представителем Cambro для проверки до заказа.",
      search_results: {
        your_togo_container: "ВАШ To-Go КОНТЕЙНЕР:",
        options: {
          gobag: "GoBag",
          gobox: "GoBox",
          gobags: "GoBags",
          goboxes: "GoBoxes",
        },
        actions: {
          size_another_container: "Размер  другого контейнера",
          product_page: "страница продукта",
          quote_request: "Запрос квоты",
        },
        hold_capacity_message:
          "Этот {transporterType} может вместить {numBoxes} ваших To-Go контейнеров",
        containers_needed_count_message:
          "You need {numBags} of these {transporterType} to carry {count} containers",
      },
    },
  },
}
